import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: [],
};

export const statusSlice = createSlice({
  name: "status",
  initialState,
  reducers: {
    setStatus: (state, action) => {
      console.log("state, action", state, action);
      state.status = action.payload;
    },
  },
});

export const { setStatus } = statusSlice.actions;

const statusSliceReducer = statusSlice.reducer;

export default statusSliceReducer;
